<template>
    <Dialog :open="true" @update:open="$emit('close')">
        <DialogContent class="sm:max-w-lg">
            <DialogHeader>
                <DialogTitle>Pairing QR Code</DialogTitle>
            </DialogHeader>

            <div class="space-y-4">
                <p class="text-sm text-muted-foreground">
                    <span class="font-medium text-foreground">Two-Factor Authentication is enabled.</span>
                    You can pair another device or app as authenticator by scanning the QR code below.
                </p>

                <div class="flex items-start gap-6">
                    <div v-if="paringCodes.qrCode" class="shrink-0 rounded-md border p-4" v-html="paringCodes.qrCode"></div>
                    <div v-else class="flex size-[150px] shrink-0 items-center justify-center rounded-md border">
                        <div class="size-6 animate-spin rounded-full border-2 border-new-neutral-300 border-t-new-neutral-900"></div>
                    </div>

                    <div class="space-y-3">
                        <div>
                            <p class="text-sm font-medium">Scan the QR Code</p>
                            <p class="text-xs text-muted-foreground">
                                Open the
                                <a href="https://authy.com/download/" target="_blank" class="font-medium text-new-blue-500 hover:text-new-blue-600">Authenticator App</a>,
                                tap the "+" and scan the image using your phone or tablet.
                            </p>
                        </div>
                        <div>
                            <p class="text-xs font-medium">Manual Entry Key:</p>
                            <p class="text-xs text-muted-foreground font-mono break-all">{{ paringCodes.key }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <DialogFooter class="mt-4">
                <Button size="lg" @click="$emit('close')">Done</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import useParingCodes from '@/Pages/Settings/Profile/composable/usePairingCodes';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

defineEmits<{
    close: [];
}>();

const { paringCodes } = useParingCodes('auth.two-factor-authentication-pairing-codes');
</script>
